import { render, staticRenderFns } from "./common-sesure-box.vue?vue&type=template&id=20e88b18&scoped=true"
import script from "./common-sesure-box.vue?vue&type=script&lang=js"
export * from "./common-sesure-box.vue?vue&type=script&lang=js"
import style0 from "./common-sesure-box.vue?vue&type=style&index=0&id=20e88b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e88b18",
  null
  
)

export default component.exports